import styled from 'styled-components'
import * as C from '../util/Colors'

export const ContainerDegrade = styled.div`
    width:100%;
    background-image: linear-gradient(${C.SECONDARY}, ${C.PRIMARY});
    padding:0;
    margin:0;
    display:flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
`;

export const BoxForm = styled.div`
    width:70rem;
    padding:0;
    margin:0;
    min-height: 400px;
    text-align:center;
    flex:3;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const Input = styled.input`
    display: block;
    width: 400px;
    height: 40px;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 2;
    color: ${C.GREY_INPUT};
    background-color: ${C.WHITE};
    background-clip: padding-box;
    border: 1px solid #C4CDD3;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    margin: 15px auto;
    font-size:20px;

    &::placeholder {
        text-align: center;
    }
    &:-ms-input-placeholder {
        text-align: center;
    }
    &::-ms-input-placeholder {
        text-align: center;
    }
`;

export const InfosLogin = styled.div`
    width:100%;
    text-align:center;
    flex:1;
`;

export const BoxBtn = styled.div`
    margin-top:20px;
    width:100%;
    height: 60px;
    display:flex;
    justify-content: center;
    align-items: center;
`;

export const Lang = styled.div`
    position: fixed;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.15);
    padding: 8px 14px;
    border-radius: 20px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s ease;
    backdrop-filter: blur(5px);
    z-index: 1000;

    &:hover {
        background-color: rgba(255, 255, 255, 0.25);
    }
`;